import * as acqDisp from './acqdisp.js';

export default {
    acqDisp,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // acqDisp
    window.EQLAPP.ACQDISP = window.EQLAPP.ACQDISP || {};
    Object.entries(acqDisp).forEach(([key, value]) => {
        window.EQLAPP.ACQDISP[key] = value;
    });

}